import { cx } from "@linaria/core";
import { useEffect } from "react";

import type { PageDescriptor } from "@pm2/api";
import type { BookshelfComponent, BookShelfModel } from "@pm2/bookshelf-page";
import { pm2CurrentAST } from "@pm2/content-engine";
import { type PM2ConfigStore } from "@pm2/store";
import type { UserIdentity } from "@provider/user-identity";

import * as css from "./page.shelf.style";

type Props = {
  descriptor: PageDescriptor;
  BookshelfComponent: typeof BookshelfComponent;
  model: BookShelfModel;
};

function ShelfPage(props: Props): React.JSX.Element {
  useEffect(() => {
    pm2CurrentAST.current = undefined;
  }, []);

  return (
    <div className={cx("gPortal-page", css.wrapperCls)}>
      <props.BookshelfComponent bookshelf={props.model} />
    </div>
  );
}

export async function renderBookShelf(
  user: UserIdentity | null | undefined,
  configStore: PM2ConfigStore,
  pageDescriptor: PageDescriptor,
): Promise<React.JSX.Element> {
  const { BookshelfComponent, getBookshelf } = await import(
    "@pm2/bookshelf-page"
  );

  const configState = configStore.getState();
  const bookShelfModel = await getBookshelf(
    configState.config.id,
    pageDescriptor.id,
    {
      previewMode: configState.previewMode,
    },
  );

  // fetch user data if a user is currently signed in to the portal
  if (user) {
    await bookShelfModel.fetchUserData(
      user.id,
      user.institution?.id,
      configState.config.uniqueId,
    );
  }

  return (
    <ShelfPage
      descriptor={pageDescriptor}
      BookshelfComponent={BookshelfComponent}
      model={bookShelfModel}
    />
  );
}
